// Shared primitives for Backtest.js and its extracted results tree
// (src/pages/backtest/Results.js). Pure code-motion out of the former
// Backtest.js god file (Tech Debt 2026-09 "Assessment and Backtest are god
// files" ticket) -- no behaviour change, byte-identical logic. fmtMoney,
// fmtPct and DEFAULT_CAD_PER_USD are the pieces both the runner form
// (Backtest.js itself -- SavedRunsPanel's saved-run preview row, the
// practical-capital-ceiling tooltip, and the cadPerUsd default state) and
// the results tree need.
export const DEFAULT_CAD_PER_USD = 1.37;

export function fmtMoney(v, inCad, cadPerUsd = DEFAULT_CAD_PER_USD) {
  if (v == null) return '—';
  const display = inCad ? v * cadPerUsd : v;
  const suf = inCad ? ' CAD' : ' USD';
  const a = Math.abs(display);
  if (a >= 1e12) return `${v >= 0 ? '' : '-'}$${(Math.abs(display) / 1e12).toFixed(2)}T${suf}`;
  if (a >= 1e9)  return `${v >= 0 ? '' : '-'}$${(Math.abs(display) / 1e9 ).toFixed(2)}B${suf}`;
  if (a >= 1e6)  return `${v >= 0 ? '' : '-'}$${(Math.abs(display) / 1e6 ).toFixed(2)}M${suf}`;
  if (a >= 1e3)  return `${v >= 0 ? '' : '-'}$${(Math.abs(display) / 1e3 ).toFixed(0)}k${suf}`;
  return `${display >= 0 ? '' : '-'}$${Math.abs(Math.round(display)).toLocaleString()}${suf}`;
}

export function fmtPct(v, d = 1) {
  if (v == null) return '—';
  return (v >= 0 ? '+' : '') + v.toFixed(d) + '%';
}
